export function getFormTypeAccess() {
  return document.querySelector('html')?.getAttribute('type-access');
}
